var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0703 13.2129C23.5636 13.2129 22.217 13.9462 21.377 15.0662C20.537 13.9462 19.1903 13.2129 17.6836 13.2129C15.137 13.2129 13.0703 15.2929 13.0703 17.8529C13.0703 18.8396 13.2303 19.7596 13.497 20.5996C14.8036 24.7462 18.857 27.2396 20.857 27.9196C21.137 28.0129 21.6036 28.0129 21.8836 27.9196C23.8836 27.2396 27.937 24.7596 29.2436 20.5996C29.5236 19.7462 29.6703 18.8396 29.6703 17.8529C29.6836 15.2929 27.617 13.2129 25.0703 13.2129Z",
    fill: "#30BEAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6641 11.1195C27.6641 11.4261 27.3574 11.6261 27.0641 11.5461C25.2641 11.0795 23.2907 11.4661 21.7974 12.5328C21.5041 12.7461 21.1041 12.7461 20.8241 12.5328C19.7707 11.7595 18.4907 11.3328 17.1441 11.3328C13.7041 11.3328 10.9041 14.1461 10.9041 17.6128C10.9041 21.3728 12.7041 24.1861 14.5174 26.0661C14.6107 26.1595 14.5307 26.3195 14.4107 26.2661C10.7707 25.0261 2.66406 19.8795 2.66406 11.1195C2.66406 7.25281 5.77073 4.13281 9.61073 4.13281C11.8907 4.13281 13.9041 5.22615 15.1707 6.91948C16.4507 5.22615 18.4641 4.13281 20.7307 4.13281C24.5574 4.13281 27.6641 7.25281 27.6641 11.1195Z",
    fill: "#30BEAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniHeart);
export default __webpack_public_path__ + "static/media/mini-heart.7145fa31093b07092d7d6b77174baeb2.svg";
export { ForwardRef as ReactComponent };